import { ApolloError, ApolloQueryResult } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

export class ApolloQueryErrorMapper {
	public static getError<T>(
		queryResult: ApolloQueryResult<T>
	): ApolloError | ReadonlyArray<GraphQLFormattedError> | Error {
		return queryResult.error ?? queryResult.errors ?? new Error('unknown error ocurred');
	}
}
